// Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <nav className="footer-nav">
        <a href="mailto:charlesdavid@mupende.com">E-Mail</a>
        <a
          href="https://www.linkedin.com/in/charlesmupende/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://github.com/bandundu"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <Link to="/impressum">Impressum</Link>
      </nav>
      <div className="footer-credit">
        Design and Dev by{" "}
        <a href="#" target="_blank" rel="noopener noreferrer">
          Charles David Mupende
        </a>
      </div>
    </footer>
  );
}
